// extracted by mini-css-extract-plugin
export default {"orange01":"#F29320","StaleIcon":"StaleIconLight__StaleIcon___CkLmi"};